import type { ReactNode } from 'react';

export const ProvidersGrid = ({ children }: { children: ReactNode }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 content-center md:grid-cols-4 gap-x-2.5 sm:gap-x-5 gap-y-4.5 sm:gap-y-7">
    {children}
  </div>
);
